
import { Options, Vue } from 'vue-class-component';
import * as OM from '@/model';
import { NetworkClient } from '@/services/Services';
import store from '@/store';
import { Prop } from 'vue-property-decorator';

@Options({})
export default class networkTree extends Vue {

    @Prop() rootItem: OM.NetworkUserVm;
    @Prop() canWa: boolean;
    
    isOpen: boolean = false;
    firstLine: OM.NetworkUserVm[] = null;

    load(){
        if(this.isOpen){
            this.isOpen = false;
        } else {
            this.isOpen = true;
            if(!this.firstLine){
                NetworkClient.getFirstLineOf(this.rootItem.identifier)
                .then(x => {
                    this.firstLine = x;
                })
            }
        }
    }

}
